import { AxiosConfig } from '../../componentes/axiosConfig';

export class CriarItemAlbumRastreavel {
    constructor() {
        this._axios = (new AxiosConfig()).instanciaAxios();

        this._formAddItemAlbum   = 'form[name=form-add-item-album-rastreavel]';
        this._idFormAddItemAlbum = 'form-add-item-album-rastreavel';
        this._idContainerAlbum   = 'container-album-rastreavel';
        this._idLinkAddItemAlbum = 'add-item-album-rastreavel';
    }

    executar() {
        const containerAlbum = $(`#${this._idContainerAlbum}`);
        if (containerAlbum.length === 0) {
            return;
        }

        containerAlbum.on('click', `#${this._idLinkAddItemAlbum}`, (evento) => {
            evento.preventDefault();
            this._criarVisao();
        });

        containerAlbum.on('submit', this._formAddItemAlbum, (evento) => {
            evento.preventDefault();
            this._criarLogica();
        });
    }

    _criarVisao() {
        const linkCriarItemAlbum = document.getElementById(this._idLinkAddItemAlbum);
        const containerAlbum     = document.getElementById(this._idContainerAlbum);

        this._axios.get(linkCriarItemAlbum.href)
        .then((response) => {
            containerAlbum.innerHTML = response.data;
            this._ativarSelect2();
        })
        .catch((error) => {
            console.log(error);
        });
    }

    _criarLogica() {
        const urlAddItemAlbum = document.querySelector(this._formAddItemAlbum).action;
        const dadosFormulario = new FormData(document.getElementById(this._idFormAddItemAlbum));
        const containerAlbum  = document.getElementById(this._idContainerAlbum);
        if (!this._tamnhoArquivoValido()) {
            return;
        }

        this._axios.post(urlAddItemAlbum, dadosFormulario)
        .then((response) => {
            if (response) {
                containerAlbum.innerHTML = response.data;
            }
        })
        .catch((error) => {
            console.log(error);
        });
    }

    /**
     * Checa se o tamnaho do arquivo que está sendo enviado via upload é valido.
     *
     * @private
     * @returns {boolean}
     */
    _tamnhoArquivoValido() {
        const inputArquivo = document.getElementById('arquivo');
        if (!inputArquivo) {
            return true;
        }

        const permitido = 100*1024*1024; // 100MB
        const arquivo   = inputArquivo.files[0];
        if (arquivo && arquivo.size > permitido) {
            $.toast({
                heading     : 'Opa! algo deu errado',
                text        : 'Arquivo execede o tamanho máximo permitido, 100MB',
                position    : 'top-right',
                loaderBg    : '#fec107',
                icon        : 'error',
                hideAfter   : 8000,
                stack       : 6
            });

            return false;
        }

        return true;
    }

    _ativarSelect2() {
        $('.select2-js').select2();
    }
}
